// 이터널 리턴 낮/밤 주기 (게임 시작부터 각 구간의 지속시간, 초 단위).
// 8일차 낮까지만 제공되어 그 이후(약 25.8분~)는 음영 없이 둔다.
export const DAY_NIGHT_CYCLE = [
  { phase: 'day', seconds: 140 },   // 1일 낮
  { phase: 'night', seconds: 110 }, // 1일 밤
  { phase: 'day', seconds: 130 },   // 2일 낮
  { phase: 'night', seconds: 120 }, // 2일 밤
  { phase: 'day', seconds: 130 },   // 3일 낮
  { phase: 'night', seconds: 110 }, // 3일 밤
  { phase: 'day', seconds: 100 },   // 4일 낮
  { phase: 'night', seconds: 110 }, // 4일 밤
  { phase: 'day', seconds: 80 },    // 5일 낮
  { phase: 'night', seconds: 80 },  // 5일 밤
  { phase: 'day', seconds: 70 },    // 6일 낮
  { phase: 'night', seconds: 50 },  // 6일 밤
  { phase: 'day', seconds: 120 },   // 7일 낮
  { phase: 'night', seconds: 50 },  // 7일 밤
  { phase: 'day', seconds: 150 },   // 8일 낮
];

export const DAY_NIGHT_FILL = { day: '#FFF8E1', night: '#E8EAF6' };
// 지금(현재) 구간을 강조할 때 쓰는 진한 색 (화면 도우미의 파워 커브)
export const DAY_NIGHT_FILL_CURRENT = { day: '#FFE082', night: '#9FA8DA' };

// N일차 낮/밤 → 낮/밤 주기 표(DAY_NIGHT_CYCLE)의 위치(낮=짝수, 밤=홀수). 일차를 모르거나 표에 없으면 null.
export const currentCycleIndex = (current) => {
  if (!current || current.day === null || current.day === undefined || current.day < 1) return null;
  const index = (current.day - 1) * 2 + (current.phase === 'night' ? 1 : 0);
  return index < DAY_NIGHT_CYCLE.length ? index : null;
};

// 낮/밤 주기를 분 단위 x축 세그먼트로 변환하고, 표시 범위 [1, maxBucket] 로 클램프한다.
// 데이터가 짧으면 뒤 구간은 제외되고, 길면 정의된 구간(8일차 낮)까지만 칠해진다.
export const buildDayNightSegments = (maxBucket) => {
  if (!maxBucket || maxBucket <= 1) return [];
  const segments = [];
  let startSec = 0;
  DAY_NIGHT_CYCLE.forEach(({ phase, seconds }, cycleIndex) => {
    const x1 = Math.max(startSec / 60, 1);
    const x2 = Math.min((startSec + seconds) / 60, maxBucket);
    startSec += seconds;
    if (x1 < x2) segments.push({ phase, x1, x2, cycleIndex });
  });
  return segments;
};

// 일차(낮+밤)별로 묶어 숫자 라벨을 둘 위치를 만든다.
// DAY_NIGHT_CYCLE 은 [1일 낮, 1일 밤, 2일 낮, 2일 밤, ...] 순서라 2개씩 한 일차.
// 라벨 위치(labelX): 낮+밤이 다 보이면 낮/밤 경계(낮 끝), 낮만 보이면 낮의 중앙.
// 표시 범위 [1분, maxBucket] 로 클램프하고, 구간 span/labelX 를 분 단위로 반환한다.
export const buildDayLabelSegments = (maxBucket) => {
  if (!maxBucket || maxBucket <= 1) return [];
  const minSec = 60; // x축은 1분부터 표시
  const maxSec = maxBucket * 60;
  const days = [];
  let startSec = 0;
  DAY_NIGHT_CYCLE.forEach(({ phase, seconds }, index) => {
    const dayIndex = Math.floor(index / 2);
    if (!days[dayIndex]) {
      days[dayIndex] = { day: dayIndex + 1, startSec, switchSec: startSec, endSec: startSec, hasNight: false };
    }
    const d = days[dayIndex];
    if (phase === 'day') {
      d.switchSec = startSec + seconds; // 낮 끝 = 낮/밤 경계
    } else {
      d.hasNight = true;
    }
    d.endSec = startSec + seconds;
    startSec += seconds;
  });
  const result = [];
  for (const d of days) {
    const x1Sec = Math.max(d.startSec, minSec);
    const x2Sec = Math.min(d.endSec, maxSec);
    if (x1Sec >= x2Sec) continue;
    let labelSec;
    if (d.hasNight && d.switchSec > x1Sec && d.switchSec < x2Sec) {
      labelSec = d.switchSec; // 낮/밤 경계
    } else {
      const visibleDayEnd = Math.min(d.switchSec, x2Sec); // 낮만 보이는 경우의 낮 끝
      labelSec = (x1Sec + Math.max(visibleDayEnd, x1Sec)) / 2; // 보이는 낮 구간 중앙
    }
    labelSec = Math.min(Math.max(labelSec, x1Sec), x2Sec);
    result.push({ day: d.day, x1: x1Sec / 60, x2: x2Sec / 60, labelX: labelSec / 60 });
  }
  return result;
};
